<template>

  <div class="full-calendar-container">

    <full-calendar :options="options"></full-calendar>

  </div>

</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'

export default {
  components: {
    'full-calendar': FullCalendar,
  },

  props: {
    dataUrl: {
      type: String,
      required: true,
    },
  },

  data () {
    return {
      loading: false,
    }
  },

  computed: {
    mobileMode () {
      return this.$store.getters['isMobile']
    },
    
    options () {
      return {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        headerToolbar: {
          start: 'prev',
          center: 'title',
          end: 'next',
        },
        dayHeaderFormat: {
          weekday: 'short',
        },
        eventClick: this.eventClick,
        events: this.fetchEvents,
        aspectRatio: 1.6,
        height: this.mobileMode ? 'auto' : null,
      }
    },
  },

  watch: {},

  created () {
  },

  mounted () {
  },

  methods: {
    eventClick (e) {
      console.info(e)
    },

    /**
     * Fetch our event data from serverside, filtering down to a specified date range.
     * Transform this data into what FullCalendar expects.
     *
     * @return Array
     */
    fetchEvents (info, onSuccess, onFailure) {
      if (!this.loading) {
        this.loading = true

        // Check with our backend
        axios.get(this.dataUrl, {
          params: {
            page: 1,
            maxResults: 100,
            filters: { from: info.startStr, to: info.endStr }
          }
        })
            .then((response) => {
              let data = response.data
              let events = []

              for (let model of data.data) {
                events.push(model.event)
              }

              onSuccess(events)
            }).catch((error) => {
          this.loading = false

          onFailure(error)
        })
      }
    },
  },
}
</script>
